import React, {Component} from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

import find from "lodash/find";

interface ModalAddWidgetProps {
  show: boolean,
    onHandleClose: Function,
    onAddWidget: Function,
    widgetTypes: any
}

interface ModalAddWidgetState {
  widget: {
    type: number,
      title: string
  },
    errors: any
}

class ModalAddWidget extends Component<ModalAddWidgetProps, ModalAddWidgetState> {

  constructor(props: any) {
    super(props);

    this.handleAddWidget = this.handleAddWidget.bind(this);
    this.handleFormChangeSelect = this.handleFormChangeSelect.bind(this);
    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      widget: {
        type: 0,
        title: ''
      },
      errors: []
    };
  }

  resetState() {
    this.setState({
      widget: {
        type: 0,
        title: ''
      },
      errors: []
    });
  }

  handleFormChangeSelect(event: React.ChangeEvent<{ name?: string; value: unknown }>) {
    event.persist();
    this.setState((prevState:any) => ({widget: {
      ...prevState.widget,
      [event.target.name as string]: event.target.value,
    },
    }));
  }

  handleFormChangeInput(event: React.ChangeEvent<HTMLInputElement>) {
    let value = event.target.value;
    let name = event.target.name;
    this.setState((prevState:any) => ({widget: {
      ...prevState.widget,
      [name as string]: value,
    }}));
  }

  renderShowTypeMenuOptions(type:any) {
    //TODO Add additional form information later based off of widget type
    switch(parseInt(type, 10)) {
      case 1:
        return (<div></div>);
      case 2:
        return (<div></div>);
      case 0:
        return (<div></div>);
      default:
        return (<em></em>);
    }
  }

  handleClose() {
    const { onHandleClose} = this.props;
    this.resetState();
    onHandleClose();
  }

  async handleAddWidget(event:any) {
    const { widget } = this.state;
    const newErrors = [];

    event.preventDefault();
    event.stopPropagation();

    // Check to see if things are setup correctly
    // Type must be set and not zero
    if (widget.type === 0) {
      newErrors.push({
        type: 'type',
        message: 'Please select a widget type.'
      });
    }

    // Title must be set
    if (widget.title.trim().length === 0 ) {
      newErrors.push({
        type: 'title',
        message: 'Please enter a widget title.'
      });
    }

    // Title is limited to 50 characters
    if (widget.title.trim().length > 50 ) {
      newErrors.push({
        type: 'title',
        message: 'Please enter a title less than 50 characters.'
      });
    }

    this.setState({errors: newErrors});

    if (newErrors.length === 0) {
      await this.props.onAddWidget(this.state.widget);
      await this.props.onHandleClose();
      this.resetState();
    }
  }

  checkValueTypeHasError(type:string) {
    const { errors } = this.state;
    if (!errors || errors.length === 0 ) {
      return false;
    }

    const errorFound = find(errors, (error:any) =>
      error.type === type
    );

    if (errorFound) {
      return true;
    }
    return false;
  }

  renderWidgetOptions() {
    const { widgetTypes } = this.props;
    const { widget } = this.state;
    if (!widgetTypes) {
      return <div></div>;
    }
    const widgetTypeOptions = widgetTypes.map((widgetInstanceData:any) => {
      return <option
        key={widgetInstanceData.id}
        value={widgetInstanceData.id}
      >{widgetInstanceData.name}
      </option>
    });
    return (
      <Form.Group>
        <Form.Label>Widget Type</Form.Label>
        <Form.Control
          as="select"
          value={widget.type ? widget.type.toString() : "0"}
          className="form-control"
          name="type"
          id="widget-type"
          isInvalid={this.checkValueTypeHasError('type')}
          // @ts-ignore https://github.com/react-bootstrap/react-bootstrap/commit/74a36bcf8cc2d355efd420674b31ed22c14e2893
          onChange={this.handleFormChangeSelect}
          required
        >
          <option value="0">Select a Widget Type</option>
          {widgetTypeOptions}
        </Form.Control>
      </Form.Group>
    );
  }

  showErrors() {
    const { errors } = this.state;

    if (!errors || errors.length === 0) {
      return '';
    }

    const errorsElements = errors.map((error:any, idx:number) => {
      return (
        <Alert key={idx} variant="danger">
          {error.message}
        </Alert>
      );
    });

    return errorsElements;
  }

  render() {
    const { show } = this.props;
    const { widget } = this.state;

    return (
      <Modal
        size="lg"
        show={show}
        centered
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add a new Widget</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={this.handleAddWidget}>
            {this.showErrors()}

            {this.renderWidgetOptions()}
            <Form.Group>
              <Form.Label>Widget Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={widget.title}
                // @ts-ignore https://github.com/react-bootstrap/react-bootstrap/commit/74a36bcf8cc2d355efd420674b31ed22c14e2893
                onChange={this.handleFormChangeInput}
                placeholder="Example Widget Title"
                isInvalid={this.checkValueTypeHasError('title')}
              />
            </Form.Group>
            {this.renderShowTypeMenuOptions(widget.type)}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
          <Button variant="primary" onClick={this.handleAddWidget}>Add Widget</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalAddWidget;
